module.exports = __webpack_public_path__ + "static/media/img_sendero.d48d85ac.jpg";